import React, { useState, useEffect, useRef } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

import Page from '../Page.js';
import PageContentWrapper from "../../components/PageContentWrapper.js";
import uiManager from '../../../config/ui.js';
import PAGES from '../../data/PagesConstants.js';
import FormPartial from './FormPartial.js';
import SecurityAmountDisplay from '../../models/SecurityAmountDisplay.js';
import { getApi } from '../../api/endpoints.js';

const Edit = (props) => {
  const navigate = useNavigate();
  let securityAmountDisplayObj = new SecurityAmountDisplay();
  const [securityAmountDisplay, setSecurityAmountDisplay] = useState(securityAmountDisplayObj.toStateJson());
  const [fetchApi] = getApi('showSecurityAmountDisplay');
  const [updateApi] = getApi('updateSecurityAmountDisplay');

  const params = useParams();

  const getRecord = async (params) => {
    try {
      let response = await fetchApi({ id: params.id }).unwrap();
      setSecurityAmountDisplay((new SecurityAmountDisplay(response.data.security_amount_display)).toStateJson());
    } catch(error) {

    }
  }

  const updateRecord = async (params) => {
    try {
      let response = await updateApi(params).unwrap();
      navigate("/security_amounts")
    } catch(error) {
      securityAmountDisplayObj = new SecurityAmountDisplay(securityAmountDisplay);
      securityAmountDisplayObj.set_api_errors(error.data.data.errors);
      setSecurityAmountDisplay(securityAmountDisplayObj.toStateJson())
    }
  }

  useEffect(() => {
    getRecord({ id: params.id })
  }, []);


  const onUpdateClick = () => {
    updateRecord((new SecurityAmountDisplay(securityAmountDisplay)).toApiJson())
  }

  const onBackClick = () => {
    navigate("/security_amounts")
  }

  return (
    <Page
      uiPage={uiManager.getUiPage(PAGES.EditSecurityAmountPage.name)}
      breadcrumbs={[{ label: "Home", url: '/dashboard' }, { label: "Security Amount List", url: '/security_amounts'}, { label: "Edit Security Amount" }]}
      className={'edit-security-amount-page'}
    >
      <PageContentWrapper contentHeading={"Edit Security Amount"}>
        <div className='m-3'>
          <div className='mb-4 col-md-12'>
            <form className="row g-3" autoComplete="off">
              <FormPartial securityAmountDisplay={securityAmountDisplay} setSecurityAmountDisplay={setSecurityAmountDisplay} />
              <div className='mb-4 col-md-12'>
                <div >
                  <button style={{ float: 'inline-start' }} type="button" className="btn btn-voltup-theme" onClick={onBackClick}>Back</button>
                  <button type="button" className="btn btn-voltup-theme ms-3" onClick={onUpdateClick}>Update Security Amount</button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </PageContentWrapper>
    </Page>
  );
}

export default Edit;
